module.exports = __webpack_public_path__ + "static/media/top.50b47ab3.jpg";